export const PIE_CHART_STATISTICS = "PIE_CHART_STATISTICS";
export const PIE_CHART_STATISTICS_SUCCESS = "PIE_CHART_STATISTICS_SUCCESS";
export const PIE_CHART_STATISTICS_FAILED = "PIE_CHART_STATISTICS_FAILED";

export const CUSTOMER_STATISTICS = "CUSTOMER_STATISTICS";
export const CUSTOMER_STATISTICS_SUCCESS = "CUSTOMER_STATISTICS_SUCCESS";
export const CUSTOMER_STATISTICS_FAILED = "CUSTOMER_STATISTICS_FAILED";

export const EVENTS_STATISTICS = "EVENTS_STATISTICS";
export const EVENTS_STATISTICS_SUCCESS = "EVENTS_STATISTICS_SUCCESS";
export const EVENTS_STATISTICS_FAILED = "EVENTS_STATISTICS_FAILED";

export const RIDES_STATISTICS = "RIDES_STATISTICS";
export const RIDES_STATISTICS_SUCCESS = "RIDES_STATISTICS_SUCCESS";
export const RIDES_STATISTICS_FAILED = "RIDES_STATISTICS_FAILED";
